/**
 * Global prefix for all components.
 */
export const prefix = 'unistra-';
